import ModalLoginAndRegister from "../../partials/modals/loginAndRegister/ModalLoginAndRegister";
import ModalEditProfile from "../../partials/modals/editProfile/ModalEditProfile";
import ModalMyWallet from "../../partials/modals/myWallet/ModalMyWallet";
import ModalMyOrders from "../../partials/modals/myOrders/ModalMyOrders";
import ModalAddAddress from "../../partials/modals/Address/ModalAddAddress";
import ModalChangeAddress from "../../partials/modals/Address/ModalChangeAddress";
import ModalFinalizeRegistration from "../../partials/modals/FinalizeRegistration/ModalFinalizeRegistration";
import ModalEditAddress from "../../partials/modals/Address/ModalEditAddress";
import ModalAddPrice from "../../partials/modals/addPrice/ModalAddPrice";
import {ToastContainer} from "react-toastify";
import ModalSurvey from "../../partials/modals/Survey/ModalSurvey";
import ModalInvoice from "../../partials/modals/invoice/ModalInvoice";
import ModalOrderDetails from "../../partials/modals/OrderDetails/ModalOrderDetails";
import ModalPwaIsIos from "../../partials/modals/isIOS";
import React from "react";
import ModalInvitation from "../modals/ModalInvitation";
import ModalMyDiscounts from "../modals/ModalMyDiscounts";

import ModalRankGuide from "../../partials/modals/rankGuide/ModalRankGuide";
import ModalMyFoodPacks from "../modals/ModalMyFoodPacks";
import ModalEditOrderDeliveryDateTime from "../modals/editOrderDeliveryDateTime";
import ModalEditOrderDescGratuity from "../modals/editOrderDescGratuity";
import ModalGratuity from "../modals//gratuity/ModalGratuity";
import ModalMyCarrotWallet from "../../partials/modals/myCarrotWallet/ModalMyCarrotWallet";

const ImportModals = () => {
    return (
        <div id={'base-box-all-modals'}>
            <ModalLoginAndRegister/>
            <ModalEditProfile/>
            <ModalMyWallet/>
            <ModalMyOrders/>
            <ModalAddAddress/>
            <ModalChangeAddress/>
            <ModalFinalizeRegistration/>
            <ModalEditAddress/>
            {/*SM MODALS*/}
            <ModalAddPrice/>
            {/*Toast*/}
            <ToastContainer autoClose={2000} rtl/>
            {/*نظرسنجی*/}
            <ModalSurvey/>

            <ModalInvoice/>

            <ModalOrderDetails/>

            <ModalPwaIsIos/>

            <ModalInvitation/>

            <ModalMyDiscounts/>
            
            <ModalRankGuide/>
            
            <ModalMyFoodPacks/>
            
            <ModalEditOrderDeliveryDateTime/>
            
            <ModalEditOrderDescGratuity/>
            
            <ModalGratuity/>
            
            <ModalMyCarrotWallet/>
        </div>
    );
}

export default ImportModals;
